export const stringifyEventData = (
  values: Array<string | number | boolean | null | undefined>
) => values.map(value => (value == null ? '' : value)).join('|');
